/*globals _*/
angular
    .module('MW.ContactManager.ContactManagerFilterService', [
        'Configuration',
        'MW.ContactManager.FilterFactory',
        'MW.Framework.EntitlementService'
    ])
    .service('ContactManagerFilterService', [
        '$http',
        'CONTACT_MANAGER_FILTER_URL',
        '$q',
        'ContactManagerFilterFactory',
        'EntitlementService',
        function($http, CONTACT_MANAGER_FILTER_URL, $q, ContactManagerFilterFactory, EntitlementService) {
            'use strict';
            this.getAllFilterOptions = function getAllFilterOptions() {
                var defer = $q.defer();

                $http.get(CONTACT_MANAGER_FILTER_URL).then(function onGetOptionsSuccess(response) {
                    EntitlementService.getIcmCountriesEntitlement().then(function afterGetIcmCountriesEntitlement(entitledCountriesList) {
                        var countriesList = [];

                        response.data.locations.data.forEach(function loop(location) {
                            if(location.name && entitledCountriesList.indexOf(location.name.toLowerCase()) !== -1) {
                                countriesList.push(location);
                            }
                        });

                        response.data.locations.data = countriesList;

                        defer.resolve(response.data);
                    });
                }).catch(function (response) {
                    defer.reject(response.data);
                });

                return defer.promise;
            };

            this.getLocationFilterOptions = function getLocationFilterOptions(type, country, region) {
                var defer = $q.defer(),
                    url = CONTACT_MANAGER_FILTER_URL,
                    params;

                url = url + '/' + type;
                params = country? '?country=' + country : '';

                if(region) {
                    params = params + ((params)? '&' : '?') + 'region=' + region;
                }
                $http.get(url + params).then(function onGetOptionsSuccess(response) {
                    var filters = ContactManagerFilterFactory.build(response.data);
                    defer.resolve(filters);
                }).catch(function (response) {
                    defer.reject(response.data);
                });
                return defer.promise;
            };

            this.getActiveFiltersFromFilters = function getActiveFiltersFromFilters(filters){
                var finalFilterObject = {},
                    filtersWithoutEmptyStrings,
                    filterName;

                _.each(filters, function (filter) {
                    if (filter.selected) {
                        filtersWithoutEmptyStrings = _.filter(filter.selected, function (filterId) {
                            return filterId !== '';
                        });
                        if (filtersWithoutEmptyStrings && filtersWithoutEmptyStrings.length > 0) {
                            filterName = filter.id;
                            if (filter.id === 'location') {
                                filterName = 'Location';
                            }
                            finalFilterObject[filterName] = {
                                name: filter.id,
                                selected: filtersWithoutEmptyStrings
                            };
                        }
                    }
                });

                return finalFilterObject;
            };
        }
    ]);
